/**
 * Temporary on-device diagnostic for card variant selection.
 * Inert unless the URL contains ?gatdebug=1 — safe to leave in place, safe to delete.
 * Loads before pdp-related-card.js so it can capture that file's parse/runtime errors.
 */
(() => {
  if (!/[?&]gatdebug=1/.test(window.location.search)) {
    return;
  }

  const MAX_LINES = 16;
  const lines = [];
  let panel = null;

  function render() {
    if (panel) {
      panel.textContent = lines.join("\n");
    }
  }

  function log(message) {
    lines.push(new Date().toISOString().slice(17, 23) + " " + message);
    if (lines.length > MAX_LINES) {
      lines.shift();
    }
    render();
  }

  window.addEventListener("error", (event) => {
    log(
      "JS ERROR: " +
        (event.message || "?") +
        " @ " +
        String(event.filename || "").split("/").pop() +
        ":" +
        event.lineno
    );
  });

  window.addEventListener("unhandledrejection", (event) => {
    log("PROMISE REJECT: " + event.reason);
  });

  function describe(el) {
    if (!el) {
      return "null";
    }
    let out = el.tagName.toLowerCase();
    if (el.id) {
      out += "#" + el.id;
    }
    const cls =
      typeof el.className === "string"
        ? el.className.trim().split(/\s+/).slice(0, 2).join(".")
        : "";
    return cls ? out + "." + cls : out;
  }

  function cardState(card) {
    const id = card.querySelector("[data-related-variant-id]");
    const checked = card.querySelector("[data-related-swatch]:checked");
    const select = card.querySelector("select[data-option-position]");
    const shown = card.querySelector("[data-related-swatch-selected]");
    return (
      "id=" +
      (id ? id.value : "?") +
      " checked=" +
      (checked ? checked.value : "NONE") +
      " select=" +
      (select ? select.value : "?") +
      " shown=" +
      (shown ? shown.textContent.trim() : "?")
    );
  }

  /** Runs after every deferred script, so it reflects the settled page. */
  function reportInitialState() {
    const cards = Array.from(document.querySelectorAll("pdp-related-card"));
    const card = cards[0];

    log(
      "cards=" +
        cards.length +
        " defined=" +
        Boolean(customElements.get("pdp-related-card")) +
        " upgraded=" +
        Boolean(card && typeof card.prepareForCartAdd === "function")
    );

    const counts = cards.map((item) => {
      const node = item.querySelector("[data-related-variants]");
      if (!node) {
        return "none";
      }
      const raw =
        node.getAttribute("data-related-variants") ||
        (node.tagName === "TEMPLATE" && node.content
          ? node.content.textContent
          : node.textContent);
      try {
        return JSON.parse(raw).length;
      } catch (error) {
        return "ERR(" + raw.slice(0, 12) + ")";
      }
    });

    log("variants per card: " + counts.join(","));
    log("touch=" + document.documentElement.classList.contains("has-touch"));
    if (card) {
      log("start " + cardState(card));
    }
    render();
  }

  function boot() {
    panel = document.createElement("pre");
    panel.style.cssText =
      "position:fixed;left:0;right:0;bottom:0;z-index:2147483647;margin:0;" +
      "padding:8px;background:rgba(0,0,0,.88);color:#0f0;" +
      "font:11px/1.35 ui-monospace,Menlo,monospace;white-space:pre-wrap;" +
      "max-height:45vh;overflow:auto;pointer-events:none";
    document.body.appendChild(panel);

    ["touchend", "click"].forEach((type) => {
      document.addEventListener(
        type,
        (event) => {
          const label = event.target.closest
            ? event.target.closest(".pdp-related-card__swatch-label")
            : null;
          const button = event.target.closest
            ? event.target.closest('button[type="submit"]')
            : null;

          if (!label && !button) {
            return;
          }

          const touch = event.changedTouches && event.changedTouches[0];
          const x = touch ? touch.clientX : event.clientX;
          const y = touch ? touch.clientY : event.clientY;
          let hit = "";
          if (typeof x === "number" && typeof y === "number") {
            const top = document.elementFromPoint(x, y);
            hit = (label || button).contains(top)
              ? ""
              : " INTERCEPTED by " + describe(top);
          }

          log(type + " " + describe(event.target) + hit);

          const owner = (label || button).closest("pdp-related-card");
          if (owner) {
            window.setTimeout(() => log("   -> " + cardState(owner)), 250);
          }
        },
        true
      );
    });

    if (document.readyState === "complete") {
      window.setTimeout(reportInitialState, 300);
    } else {
      window.addEventListener(
        "load",
        () => window.setTimeout(reportInitialState, 300),
        { once: true }
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
